import { Phone, Mail, MapPin, Clock } from "lucide-react";
import ContactForm from "@/components/ContactForm";

export default function Kontakt() {
  return (
    <div data-testid="kontakt-page">
      <section className="pt-32 pb-16 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-stone-500 mb-6">
            Kontakt
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight max-w-3xl">
            Sprechen Sie mit uns.
          </h1>
          <p className="mt-8 max-w-2xl text-stone-600 leading-relaxed">
            Wir freuen uns auf Ihre Anfrage. Beschreiben Sie kurz Ihr
            Projekt – wir melden uns kurzfristig mit einem Beratungstermin.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-5 gap-16">
          <div className="lg:col-span-2 space-y-10">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-stone-500 mb-4">
                Direkt erreichen
              </div>

              <ul className="space-y-6 mt-6">
                <li className="flex gap-4" data-testid="contact-info-phone">
                  <Phone size={20} strokeWidth={1.4} className="mt-1 text-[#1C1C1C]" />
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Telefon</div>
                    <a href="tel:+491711584130" className="text-base mt-1 block hover:underline">+49 171 158 41 30</a>
                  </div>
                </li>
                <li className="flex gap-4" data-testid="contact-info-email">
                  <Mail size={20} strokeWidth={1.4} className="mt-1 text-[#1C1C1C]" />
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-stone-500">E-Mail</div>
                    <a href="mailto:info@linea-boden-design.de" className="text-base mt-1 block hover:underline">
                      info@linea-boden-design.de
                    </a>
                  </div>
                </li>
                <li className="flex gap-4" data-testid="contact-info-address">
                  <MapPin size={20} strokeWidth={1.4} className="mt-1 text-[#1C1C1C]" />
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Adresse</div>
                    <div className="text-base mt-1">Linea Bodendesign<br />Weserstr. 133<br />32457 Porta Westfalica</div>
                  </div>
                </li>
                <li className="flex gap-4" data-testid="contact-info-hours">
                  <Clock size={20} strokeWidth={1.4} className="mt-1 text-[#1C1C1C]" />
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Erreichbarkeit</div>
                    <div className="text-base mt-1">Mo – Fr · 08:00 – 18:00 Uhr</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="bg-white border border-stone-200 p-8 sm:p-10">
              <h2 className="font-heading text-2xl font-medium mb-2">Beratungsanfrage</h2>
              <p className="text-sm text-stone-600 mb-8">
                Pflichtfelder sind mit * markiert.
              </p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
